/* this file is transformed by vux-loader */
/* eslint-disable */
/* this file is transformed by vux-loader */

/* eslint-disable */
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/*
 * @Description: 
 * @Author: 王佳兴
 * @Github: 
 * @Date: 2018-12-21 17:02:06
 * @LastEditors: 王佳兴
 * @LastEditTime: 2019-01-11 16:59:04
 */


import sa from 'sa-sdk-javascript'; // TODO:  兼容老版本神策方法 神策全改后删除

window.sa = sa;

var scClass = /*#__PURE__*/function () {
  // 储存上页面信息的session key
  function scClass() {
    _classCallCheck(this, scClass);

    this.frompage_url = '';
    this.frompage_name = '';
    this.store = sa.store;
    this.registerData = {
      web_version: window.version || '',
      platform: '',
      // 环境 wx app
      operation_tm: '',
      // 上报时间
      frompage_name: '',
      // 上页面name
      frompage_url: '',
      // 上页面url
      currentpage_name: '',
      // 当前页
      currentpage_url: '',
      // 当前页
      fromcode: '' // 页面来源code  xxx?isTemp=1,2,3,4,5
      // is_share:'' // 是否分享进入

    };
    this.typeList = [{
      label: '直播',
      value: 5
    }, {
      label: '录播',
      value: 6
    }, {
      label: '资讯',
      value: 3
    }, {
      label: '病例',
      value: 2
    }, {
      label: '帖子',
      value: 8
    }];
  }

  _createClass(scClass, [{
    key: "getSaSessionData",
    value: function getSaSessionData() {
      var sessionkey = scClass.sessionKey;
      var se = sessionStorage.getItem(sessionkey);
      se && sessionStorage.removeItem(sessionkey);
      se = se ? JSON.parse(se) : null;
      return se;
    }
    /*
     用于href 前保存当前页面信息 当作后续页面 上页面信息
     @params {vue_route || {frompage_url,frompage_name},href_url}
     */

  }, {
    key: "setSaSession_href",
    value: function setSaSession_href(route, url) {
      if (_typeof(route) != 'object') {
        console.error('saSessionData 类型参数类型错误');
      } else {
        if (route.fullPath) {
          sessionStorage.setItem(scClass.sessionKey, JSON.stringify({
            frompage_url: route.fullPath,
            frompage_name: route.meta.pageName
          }));
        } else {
          if (route.frompage_url) {
            sessionStorage.setItem(scClass.sessionKey, JSON.stringify(route));
          } else {
            console.error('setSaSessionData页面参数设置有误!必须有当前route实例或OBJ');
          }
        }
      }

      window.location.href = url ? url : '/html/newWechat.html';
    } //初始化神测

  }, {
    key: "init",
    value: function init() {
      sa.init({
        server_url: location.protocol === 'https:' ? 'https://data.yxvzb.com:4006/sa' : 'http://data.yxvzb.com:8006/sa',
        // config_url: 'https://data.yxvzb.com:8007/api/vtrack/config',
        // send_type:'ajax',
        show_log: true,
        // log
        is_single_page: true //设置成 true 后， 表示在单页面开发的网站中，我们会对 hashchange 和 popstate 事件进行监听，当这两个事件任何一个发生时，也会发送 $pageview 事件。默认 false。详情参考 7.9 节。

      });
    } // 登陆 (标识用户) 并且给用户设置默认属性

  }, {
    key: "login",
    value: function login(storageObj) {
      if (!storageObj || !storageObj.userDataStatus) {// sa.identify('', true);
      } else {
        sa.login(storageObj.shenceId || ''); // try {
        //   sa.setOnceProfile({
        //     companyName: storageObj.companyName || ''
        //   });
        //   sa.setOnceProfile({
        //     duties: storageObj.duties || ''
        //   });
        //   sa.setOnceProfile({
        //     nickName: storageObj.nickName || ''
        //   });
        //   sa.setOnceProfile({
        //     department: storageObj.department || ''
        //   });
        //   sa.setOnceProfile({
        //     phone: storageObj.phone? storageObj.phone + '' : ''
        //   });
        //   sa.setOnceProfile({
        //     address: storageObj.address || ''
        //   });
        //   sa.setOnceProfile({
        //     RegisterChannel: storageObj.registerChannel || ''
        //   });
        //   sa.setOnceProfile({
        //     fullName: storageObj.fullName || ''
        //   });
        //
        // } catch (err) {
        //   console.log('未获得用户缓存信息')
        // }
      }
    } // @params {data} 混合属性  公共属性

  }, {
    key: "registerPage",
    value: function registerPage(data) {
      var _this = this;

      var isTemp = [{
        label: '首关',
        value: 1
      }, {
        label: '菜单',
        value: 2
      }, {
        label: '模板消息',
        value: 3
      }, {
        label: '客服消息',
        value: 4
      }, {
        label: '图文消息',
        value: 5
      }, {
        label: '社群空间',
        value: 6
      }];
      var sessionObj = this.getSaSessionData();
      this.registerData = sessionObj && sessionObj.frompage_url ? _objectSpread(_objectSpread(_objectSpread({}, this.registerData), data), sessionObj) : _objectSpread(_objectSpread({}, this.registerData), data);

      if (this.registerData.frompage_name) {
        isTemp.forEach(function (item) {
          item.value == _this.registerData.frompage_name ? _this.registerData.frompage_name = item.label : '';
        });
      } // 神策公共属性 有乱码问题
      // sa.registerPage(modelData);
      // this.registerData = modelData

    }
    /*
    track方法封装
    @params {事件名称,时间属性}
     */

  }, {
    key: "saEvent",
    value: function saEvent(eventName) {
      var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var fn = arguments.length > 2 ? arguments[2] : undefined;
      sa.track(eventName, _objectSpread(_objectSpread({}, s), this.registerData));
    } // 浏览路径

  }, {
    key: "re_pageview",
    value: function re_pageview(data) {
      this.saEvent('re_pageview');
    } // 判断 位置

  }, {
    key: "location_func",
    value: function location_func() {
      var location = '';
      var currentpage_name = this.registerData.currentpage_name;

      if (currentpage_name.includes('专区')) {
        location = '专区内';
      } else if (currentpage_name.includes('面对面')) {
        location = '超级面对面内';
      } else if (currentpage_name.includes('搜索')) {
        location = '搜索';
      } else if (currentpage_name.includes('我的收藏')) {
        location = '我的收藏';
      } else if (currentpage_name.includes('听课记录')) {
        location = '听课记录';
      } else if (currentpage_name.includes('专题')) {
        location = '专题';
      } else if (currentpage_name.includes('商业外链')) {
        location = '商业外链';
      } else {
        location = '首页';
      }

      return location;
    } //内容消费

  }, {
    key: "re_contentview",
    value: function re_contentview(data) {
      var modelData = {
        type: '',
        // 消费类型 直播，录播，资讯，病例，看课时长上报 专题
        name: '',
        // 内容名字
        release_dt: '',
        // 直播时间/发布时间 直播是直播时间，录播是发布时间，资讯、病例是发布时间
        contentid: '',
        // 内容id
        first_cate: '',
        //一级分类
        second_cate: '',
        // 2级分类
        first_cate_id: '',
        // 1级分类id
        second_cate_id: '',
        //2级分类id
        author: '',
        //讲师/作者
        page_location: '' //位置 站内，专区内，超级面对面内

      };
      modelData.page_location = this.location_func();
      this.saEvent('re_contentview', _objectSpread(_objectSpread({}, modelData), data));
    } //互动

  }, {
    key: "re_interaction",
    value: function re_interaction(data) {
      var modelData = {
        type: '',
        // 评论，送花1，送花2，送花3，送花4，分享，意见反馈，收藏,视频下载
        contentype: '',
        //  互动主体 直播，录播，资讯，病例，站内信，论坛 专题
        contentid: '',
        // 内容id
        contentname: '',
        first_cate: '',
        //一级分类
        second_cate: '',
        // 2级分类
        first_cate_id: '',
        // 1级分类id
        second_cate_id: '',
        //2级分类id
        author: '',
        //讲师/作者
        page_location: '' //位置 站内，专区内，超级面对面内

      };
      modelData.page_location = this.location_func();
      this.typeList.forEach(function (item) {
        item.value == data.contentype && (data.contentype = item.label);
      });
      this.saEvent('re_interaction', _objectSpread(_objectSpread({}, modelData), data));
    } //专区

  }, {
    key: "re_zone",
    value: function re_zone(data) {
      var modelData = {
        event_type: '',
        // 进入 / 点击 / 分享
        zonename: '',
        // 消费类型 直播，录播，资讯，病例，看课时长上报
        zoneid: '' // 内容名字
        // contentname: '', // 直播时间/发布时间 直播是直播时间，录播是发布时间，资讯、病例是发布时间
        // contentid: '', // 内容id
        // first_cate: '', //一级分类
        // second_cate: '', // 2级分类
        // first_cate_id:  '',    // 1级分类id
        // second_cate_id:'', //2级分类id
        // contentype:'' // 内容类型

      };
      this.typeList.forEach(function (item) {
        item.value == data.contentype && (data.contentype = item.label);
      });
      this.saEvent('re_zone', _objectSpread(_objectSpread({}, modelData), data));
    } // 活动

  }, {
    key: "re_activity",
    value: function re_activity(data) {
      var modelData = {
        name: '',
        // 活动名称
        event_type: '' // 活动事件类型

      };
      this.saEvent('re_activity', _objectSpread(_objectSpread({}, modelData), data));
    } // 活动

  }, {
    key: "re_click",
    value: function re_click(data) {
      var modelData = {
        target_name: '',
        // 点击目标名字
        target_contentname: '',
        //点击目标的标题
        target_contentid: '',
        //点击目标的id
        target_contenturl: '' //点击目标的url

      };
      this.saEvent('re_click', _objectSpread(_objectSpread({}, modelData), data));
    }
  }, {
    key: "re_userinfo",
    value: function re_userinfo(data) {
      var modelData = {
        userid: '',
        // 用户id
        action_type: '',
        //类型
        register_channel: '',
        //注册来源 授权，注册，登录，完善信息，认证
        meeting_id: '' //会议id

      };
      this.saEvent('re_userinfo', _objectSpread(_objectSpread({}, modelData), data));
    }
  }]);

  return scClass;
}();

_defineProperty(scClass, "sessionKey", 'sainitdata');

export { scClass as default };